// @flow
import $ from 'jquery';
import _ from 'lodash';

const parseJson = (data: () => string): {isEmpMode?: boolean} => {
	try {
		const result = data();

		if (!result) {
			return _.stubObject();
		}

		return JSON.parse(result);
	} catch (e) {
		if (e instanceof SyntaxError) {
			e.userFriendlyMessages = [
				'Ошибка при разборе файла конфигурации',
			];
		}

		throw e;
	}
};

const resolveContextConfig = () => {
	const cfg1 = parseJson(() =>
		$('#page-dms-insurance-context').html()
	);
	const cfg2 = parseJson(() =>
		$('#page-dms-insurance-version-context').html()
	);

	const cfg = {
		...cfg1,
		...cfg2,
	};

	return _.defaults(cfg, {
		isEmpMode: false,
		hasMpVersion: '',
	});
};

export { resolveContextConfig };
